<template>
	<div>
		<div v-show="type === 'dynamics'">
			<template v-for="dynamic of dynamicList">
				<ListItemTopic v-if="dynamic.type_id == 1" :data="dynamic" :key="`${String(Math.random()) + dynamic.username}`" />
				<ListItemReply v-if="dynamic.type_id == 2" :data="dynamic" :key="`${String(Math.random()) + dynamic.username}`" />
				<ListItemFollow v-if="dynamic.type_id == 3" :data="dynamic" :key="`${String(Math.random()) + dynamic.username}`" />
				<ListItemVideo v-if="dynamic.type_id == 4" :data="dynamic" :key="`${String(Math.random()) + dynamic.username}`" />
			</template>
		</div>

		<div v-show="type === 'topic'">
			<ListItemTopic v-for="topic of topicList" :data="topic" :key="topic.id" />
		</div>

		<div v-show="type === 'reply'">
			<ListItemReply v-for="reply of replyList" :data="reply" :key="reply.id" />
		</div>

		<div v-show="type === 'study'">
			<ListItemVideo v-for="study of studyList" :data="study" :key="study.id" />
		</div>
	</div>
</template>

<script>
import ListItemTopic from './ListItemTopic'
import ListItemReply from './ListItemReply'
import ListItemVideo from './ListItemVideo'
import ListItemFollow from './ListItemFollow'
export default {
	props: ['type', 'uid'],
	data(){
		return {
			dynamicList: [],
			topicList: [],
			replyList: [],
			studyList: []
		}
	},
	watch: {
		type(newtype){
			if(newtype){
				switch(newtype){
					case 'dynamics': {
						if(this.dynamicList.length) return
						this.getDynamicsList()
						break
					}
					case 'topic': {
						if(this.topicList.length) return
						this.getTopicList()
						break
					}
					case 'reply': {
						if(this.replyList.length) return
						this.getReplyList()
						break
					}
					case 'study': {
						if(this.studyList.length) return
						this.getStudyList()
						break
					}
				}
			}
		}
	},
	mounted(){
		switch(this.type){
			case 'dynamics': {
				this.getDynamicsList()
				break
			}
			case 'topic': {
				this.getTopicList()
				break
			}
			case 'reply': {
				this.getReplyList()
				break
			}
			case 'study': {
				this.getStudyList()
				break
			}
		}
  },
	methods: {
		getDynamicsList(){
			this.$http.get('/user/dynamics', {
				params: {
					fuid: this.uid,
					start: 0,
					limit: 5
				}
			}).then(res => {
				if(res.code >= 0){
					this.dynamicList = res.data
				}
			})
		},
		getTopicList(){
			this.$http.get('/Discuss/userTread', {
				params: {
					uid: this.uid,
					type: 1,
					start: 0,
					limit: 5
				}
			}).then(res => {
				if(res.code >= 0){
					this.topicList = res.data
				}
			})
		},
		getReplyList(){
			this.$http.get('/Discuss/userTread', {
				params: {
					uid: this.uid,
					type: 2,
					start: 0,
					limit: 5
				}
			}).then(res => {
				if(res.code >= 0){
					this.replyList = res.data
				}
			})
		},
		getStudyList(){
			this.$http.get('/User/learnHistory', {
				params: {
					uid: this.uid,
					start: 0,
					limit: 5
				}
			}).then(res => {
				if(res.code >= 0){
					this.studyList = res.data
				}
			})
		}
	},
	components: {
		ListItemTopic,
		ListItemReply,
		ListItemVideo,
		ListItemFollow
	}
}
</script>